import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const whoIsOnCallRoute: InvariantJiraRoute = {
	name: 'eoc-who-is-on-call',
	path: '/jira/ops/who-is-on-call',
	exact: true,
};
